import eventsGridNames from '../events/grid';
import { useSendEvent } from '../useSendEvent';

const useCardClick = () =>
	useSendEvent<{
		index: number;
		bot_UserId: number;
	}>(eventsGridNames.cardClick, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const useGridViewed = ({ page }: { page?: number }) =>
	useSendEvent(
		eventsGridNames.viewGrid,
		page
			? {
					page_number: page,
			  }
			: undefined,
		{
			forceSendDemoUser: true,
			includeDemoUserMarker: true,
		}
	);

const useGridFiltersSubmitted = () =>
	useSendEvent<{
		text_filtered: string;
		filters_manual: 0 | 1;
		safe: 'SFW' | 'NSFW';
		age: string;
		gender?: string;
		createdBy?: string;
		desires?: string;
		sorting_bot_grid?: string[];
	}>(eventsGridNames.filterSubmitted, undefined, {
		forceSendDemoUser: true,
		includeDemoUserMarker: true,
	});

const annalsGrid = {
	useCardClick,
	useGridViewed,
	useGridFiltersSubmitted,
};

export default annalsGrid;
